import { nodePasteRule } from '@tiptap/core';

import { HashtagSelector } from '../../components/hashtag/hashtag-selector';
import { matchers } from '../config/matchers';
import { Tag } from './tag';

export const Hashtag = Tag.extend({
	name: 'hashtag',
	addOptions() {
		return {
			...this.parent?.(),
			char: '#',
			component: HashtagSelector,
			insertPrefixSpace: true,
			matchQuery: matchers.hashtag.possible,
		};
	},

	addPasteRules() {
		return [
			nodePasteRule({
				find: matchers.hashtag.paste,
				type: this.type,
				getAttributes: (match) => {
					return {
						id: match[0].slice(1),
					};
				},
			}),
		];
	},
});
